import { StudentReportPage } from "@/pages/teacher/StudentReportPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/teacher/classrooms/$classroomId/students/$studentId/report/"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { classroomId, studentId } = Route.useParams();
  return <StudentReportPage classroomId={classroomId} studentId={studentId} />;
}
